import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { config } from 'src/app/app.config';
import { Observable } from 'rxjs';
import { shareReplay, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  tokenType: String = '';
  token: String = '';
  type: String = '';
  accessToken: String = '';

  updateTokens() {
    this.tokenType = window.localStorage.getItem(config.baseURL + '/tokenType');
    this.accessToken = window.localStorage.getItem(config.baseURL + '/accessToken');
    this.token = window.localStorage.getItem(config.baseURL + '/token');
    this.type = window.localStorage.getItem(config.baseURL + '/type');
  }

  constructor(
    private http: HttpClient,
    private router: Router
  ) {

    this.tokenType = window.localStorage.getItem(config.baseURL + '/tokenType');
    this.accessToken = window.localStorage.getItem(config.baseURL + '/accessToken');
    this.token = window.localStorage.getItem(config.baseURL + '/token');
    this.type = window.localStorage.getItem(config.baseURL + '/type');
  }

  public authorizationHeader() {
    return new HttpHeaders().set('Authorization', `${this.tokenType ? this.tokenType : ''} ${this.token ? (this.token + '|') : ''}${this.type ? (this.type + '|') : ''}${this.accessToken}`);
  }

  /**
  * @param {string} email
  * @param {string} password
  * @param {string} uuid
  * @param {string} device
  * @param {string} version
  * @param {string} manufacturer
  * @param {string} platform
  * @param {string} appVersion
  * @param {string} isVirtual
  * @param {string} serial
  */
  login(body: any, type: string) {
    const endpoint = config.baseURL + (type === 'AD' ? 'Login/api/v1/Login/AD' : 'Login/api/v1/Login/Normal');
    return Observable.create((observer: any) => {
      this.http.post(endpoint, body).subscribe((data: any) => {
        observer.next(data);
        observer.complete();
      }, (error) => {
        observer.error(error);
      });
    });
  }

  /**
  * @param {string} password
  * @param {string} tempPassword
  * @param {string} newPassword
  */
  changePassword(body: any) {
    const endpoint = config.baseURL + 'Login/api/v1/ForceChangePassword';
    return this.post(endpoint, body);
  }

  /**
  * @param {string} email
  */
  forgotPassword(body: any) {
    const endpoint = config.baseURL + 'Login/api/v1/ResetPassword';
    return Observable.create((observer: any) => {
      this.http.post(endpoint, body).subscribe((data: any) => {
        observer.next(data);
        observer.complete();
      }, (error) => {
        observer.error(error);
      });
    });
  }

  getLineOALink() {
    const endpoint = config.baseURL + 'Global/api/v3/LineOaLink';
    return this.get(endpoint, false);
  }

  getLineOA(templateName: string) {
    const endpoint = config.baseURL + `template/api/v3/getLineOA?name=${templateName}`;
    return this.get(endpoint, false);
  }

  getLineOAByUser() {
    const endpoint = config.baseURL + `template/api/v3/getLineOAByUser`;
    return this.get(endpoint);
  }

  getTemplate() {
    const endpoint = config.baseURL + 'Global/api/v3/Template';
    return this.get(endpoint, false);
  }

  getDepartment() {
    const endpoint = config.baseURL + 'Global/api/v3/Department';
    return this.get(endpoint, false);
  }

  getPosition() {
    const endpoint = config.baseURL + 'Global/api/v3/Position';
    return this.get(endpoint, false);
  }

  getPrefix() {
    const endpoint = config.baseURL + 'Global/api/v3/PreFix';
    return this.get(endpoint, false);
  }

  register(body: any) {
    const endpoint = config.baseURL + 'Login/api/v1/Register';
    return this.post(endpoint, body);
  }

  switchAccount(body: any) {
    const endpoint = config.baseURL + 'Login/api/v1/Login/SwitchAccount';
    return this.post(endpoint, body);
  }

  updateProfileFirst(email: string, password: any, base64: any, tel: any) {
    const fd = new FormData();
    let blob: any;

    if (base64) {
      blob = this.dataURItoBlob(base64);
      fd.append('file', blob);
    }

    fd.append('Phone', tel);
    fd.append('Email', email);
    fd.append('Password', password);
    console.log(fd);
    const endpoint = config.baseURL + 'Profiling/api/v1/Profile/Update';

    return this.http.post(endpoint, fd, { headers: this.authorizationHeader() });
  }

  updateProfile(email: string, base64: any, phone: any, nickname: string) {

    const fd = new FormData();
    let blob: any;

    if (base64) {
      blob = this.dataURItoBlob(base64);
      // const mimeType = base64.split(',')[0].split(':')[1].split(';')[0]; // image/png
      // const extension = mimeType.split('/')[1]; // png
      // fd.append('file', blob, `Image.${extension}`);
      fd.append('file', blob, 'Image');
    }

    fd.append('Email', email);
    fd.append('Phone', phone);
    if (nickname) {
      fd.append('NickName', nickname);
    }


    const endpoint = config.baseURL + 'Profiling/api/v1/Profile/Update';

    return this.http.post(endpoint, fd, { headers: this.authorizationHeader() });
  }

  /**
  * @param {string} UserId
  * @param {string} AppVersion
  */
  syncAppVersion(body: any) {
    const endpoint = config.baseURL + 'Login/api/v1/SyncAppVersion';
    return this.post(endpoint, body);
  }

  getInitialData(suppressRedirect = false) {
    const endpoint = config.baseURL + 'Profiling/api/v1/Profile/Initial?cType=2';
    return this.get(endpoint, true, suppressRedirect);
  }

  getServiceDetail(id: any, page: number = 1, pageSize: number = 12) {
    const endpoint = config.baseURL + `Profiling/api/v1/Profile/GetServiceByCode?code=${id}&page=${page}&pageSize=${pageSize}`;
    return this.get(endpoint);
  }

  getServiceTab() {
    const endpoint = config.baseURL + `service/api/v3/GetServiceTabList`;
    return this.get(endpoint);
  }

  getNews(userID: string) {
    const endpoint = config.baseURL + 'news/api/v1/news/ListByUser?token=' + userID;
    return this.get(endpoint);
  }

  getContentHighlight() {
    const endpoint = config.baseURL + 'Profiling/api/v1/Profile/ContentHighlight';
    return this.get(endpoint);
  }

  getRewardHighlight(param: string) {
    const endpoint = config.baseURL + 'Reward/api/v1/Reward/RewardHighlight?' + param;
    return this.get(endpoint);
  }

  getNewsDetail(id: string) {
    const endpoint = config.baseURL + 'news/api/v1/news/NewsByID?id=' + id;
    console.log(endpoint);
    return this.get(endpoint);
  }

  getAnnouncement() {
    const endpoint = config.baseURL + 'Announcement/api/v3/GetListAnnounce';
    return this.get(endpoint);
  }

  setInvisibleAnnouncement(body: any) {
    const endpoint = config.baseURL + `Announcement/api/v3/Announcement-SetInvisible?${body}`;
    return this.post(endpoint, {});
  }

  mockupDateAnnouncement(body: any) {
    const endpoint = config.baseURL + `Announcement/api/v3/Announcement-MockupDate?${body}`;
    return this.post(endpoint, {});
  }

  /**
   * Records that the current user has acknowledged (รับทราบ) a specific announcement.
   * @param {number} id - The announcement ID to acknowledge
   */
  acknowledgeAnnouncement(id: number) {
    const endpoint = config.baseURL + `Announcement/api/v3/Announcement-Acknowledge?id=${id}`;
    return this.post(endpoint, {});
  }

  // Cache for current user profile
  private profileObservable: any = null;
  clearProfileCache() {
    this.profileObservable = null;
  }

  getMyProfile(id?: string, suppressRedirect = false, forceRefresh = false) {
    const currentToken = window.localStorage.getItem(config.baseURL + '/token');
    if (!id) {
       id = currentToken;
    }

    // Check if requesting current user profile
    if (id === currentToken) {
       if (forceRefresh) {
         this.profileObservable = null;
       }
       if (this.profileObservable) {
         return this.profileObservable;
       }
    }

    const endpoint = config.baseURL + `Profiling/api/v1/Profile/Get?id=${id}`;
    
    // Create new request
    const request = this.get(endpoint, true, suppressRedirect);

    // If it's for current user, cache it
    if (id === currentToken) {
       this.profileObservable = request.pipe(shareReplay(1));
       return this.profileObservable;
    }

    return request;
  }

  getMyProfile2(id?: string, suppressRedirect = false, forceRefresh = false) {
     return this.getMyProfile(id, suppressRedirect, forceRefresh);
  }

  getImageAvatar() {
    const endpoint = config.baseURL + 'Profiling/api/v1/Profile/avatar';
    return this.get(endpoint, false);
  }

  getAccountList() {
    const endpoint = config.baseURL + 'Login/api/v1/AccountList';
    return this.get(endpoint);
  }

  registerOnesignal(platform: any) {
    if (config.oneSignalID) {
      var OneSignal = window['OneSignal'] || [];
      OneSignal.push(function () {
        // Occurs when the user's subscription changes to a new value.
        OneSignal.on('subscriptionChange', function (isSubscribed) {
          console.log("The user's subscription state is now:", isSubscribed);
          OneSignal.getUserId().then(function (userId) {
            console.log("User ID is", userId);
            const token = localStorage.getItem(config.baseURL + '/token');
            this.registerDevice(token, userId, platform).subscribe((res: any) => {
              // console.table(res);
            }, (err: any) => {
              console.table(err);
            });
          });
        });
      });

    }
  }

  registerDevice(token: string, UserID: string, plt: string) {
    const body = {
      id: token,
      type: config.apiType,
      onesignalid: UserID,
      device: plt,
    };

    const endpoint = config.baseURL + 'Notification/api/v1/Notify/Register';
    return this.post(endpoint, body);
  }

  unregisterDevice(token: string, UserID: string) {
    const body = {
      id: token,
      type: config.apiType,
      onesignalid: UserID,
    };

    const endpoint = config.baseURL + 'Notification/api/v1/Notify/UnRegister';
    return this.post(endpoint, body);
  }

  notificationListing() {
    const endpoint = config.baseURL + 'Notification/api/v1/notify/Listv2';
    return this.get(endpoint);
  }

  notificationDetail(id: string) {
    const endpoint = config.baseURL + 'Notification/api/v1/Notify/NotificationByID?id=' + id;
    return this.get(endpoint);
  }

  notificationReading(token: string, messageID: string) {
    const body = {
      onesignalid: token,
      messageID: messageID,
      type: config.apiType,
    };

    const endpoint = config.baseURL + 'Notification/api/v1/notify/Read';
    return this.post(endpoint, body);
  }

  notificationDelete(token: string, messageID: string) {
    const body = {
      onesignalid: token,
      messageID: messageID,
      type: config.apiType,

    };
    const endpoint = config.baseURL + 'Notification/api/v1/notify/Delete';
    return this.post(endpoint, body);
  }

  notificationReadingAll() {
    const endpoint = config.baseURL + 'Notification/api/v1/notify/ReadAll';
    return this.get(endpoint);
  }

  notificationDeleteAll() {
    const endpoint = config.baseURL + 'Notification/api/v1/notify/DeleteAll';
    return this.get(endpoint);
  }

  private badgeRequest: Observable<any> | null = null;

  notificationCount() {
    if (this.badgeRequest) {
      return this.badgeRequest;
    }
    const endpoint = config.baseURL + 'Notification/api/v1/notify/badge';
    this.badgeRequest = this.get(endpoint).pipe(
      shareReplay(1),
      finalize(() => {
        this.badgeRequest = null;
      })
    );
    return this.badgeRequest;
  }

  sendServiceLogs(userId: string, serviceCode: any, ContentType?: any, ContentID?: any, action: any = null) {
    console.log('Send logs');
    console.log(ContentType);
    const body = {
      ServiceCode: serviceCode,
      Platform: 'Web',
      UserId: userId,
      ContentType: ContentType === undefined ? null : ContentType,
      ContentID: ContentID === undefined ? null : ContentID,
      Action: action
    };
    const endpoint = config.baseURL + 'ServiceConsume/api/v1/Save';
    return this.post(endpoint, body);
  }

  getActivityList() {
    const endpoint = config.baseURL + '';
    return this.get(endpoint);
  }

  getActivityDetail(id: any) {
    const endpoint = config.baseURL + `Activity/api/v1/activity/ActivityByID?id=${id}`;
    return this.get(endpoint);
  }

  registerActivity(id: any) {
    const endpoint = config.baseURL + `Activity/api/v1/activity/Register?activity_id=${id}`;
    return this.post(endpoint, {});
  }

  unRegisterActivity(id: any) {
    const endpoint = config.baseURL + `Activity/api/v1/activity/UnRegister?activity_id=${id}`;
    return this.post(endpoint, {});
  }

  checkInActivity(body: any) {
    const endpoint = config.baseURL + 'Activity/api/v1/activity/CheckIn';
    return this.post(endpoint, body);
  }

  getRewardStore() {
    const endpoint = config.baseURL + `Reward/api/v1/Reward/List`;
    return this.get(endpoint);
  }

  rewardMyBag() {
    const endpoint = config.baseURL + `Redemption/api/v1/redemption/MyBag`;
    return this.get(endpoint);
  }

  rewardRedemption(body: any) {
    const endpoint = config.baseURL + `Redemption/api/v1/redemption/Redeem`;
    return this.post(endpoint, body);
  }

  rewardCancel(redeemId: any, remark: any) {
    const body = {
      redeemId: redeemId,
      remark: remark
    };

    const endpoint = config.baseURL + `Redemption/api/v1/redemption/Cancel`;
    return this.post(endpoint, body);
  }

  getPoint() {
    const endpoint = config.baseURL + `Point/api/v1/Point/CheckPointAlert`;
    return this.get(endpoint);
  }

  getPageByID(id: any) {
    const endpoint = config.baseURL + `Page/api/v1/page/PageByID?id=${id}`;
    return this.get(endpoint);
  }

  getImage(url: any) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/file/urltostring?imageurl=${url}`;
    return this.get(endpoint);
  }

  getProfileCourseSummary(id: any) {
    const endpoint = config.classRoom + `api/v1/user/getProfileCourseSummaryWithAuth?EmployeeId=${id}`;
    return this.getClassroom(endpoint);
  }

  getProfileStudying(id: any, year: number, page: number, limit:number) {
    const endpoint = config.classRoom + `/api/v1/user/getProfileStudyingWithAuth?EmployeeId=${id}&year=${year}&page=${page}&limit=${limit}`;
    return this.postClassroom(endpoint, {});
  }

  getProfileCompleted(id: any, year: number, page: number, limit:number) {
    const endpoint = config.classRoom + `/api/v1/user/getProfileCompletedWithAuth?EmployeeId=${id}&year=${year}&page=${page}&limit=${limit}`;
    return this.postClassroom(endpoint, {});
  }

  getProfileStudyHours(id: any) {
    const endpoint = config.classRoom + `/api/v1/user/getProfileStudyHoursWithAuth?EmployeeId=${id}`;
    return this.postClassroom(endpoint, {});
  }

  //#region Point History
  getPointHistory(month: number, year: number) {
    const endpoint = config.baseURL + `Point/api/v1/Point/GetPointHistory?month=${month}&year=${year}`;
    return this.get(endpoint);
  }
  //#endregion

  getGreenPointHistory(month: number, year: number) {
    const endpoint = config.baseURL + `Point/api/v1/Point/GetGreenPointHistory?month=${month}&year=${year}`;
    return this.get(endpoint);
  }

  getPointExpiring(year: number) {
    const endpoint = config.baseURL + `Point/api/v3/getMyPointExprire?year=${year}`;
    return this.get(endpoint);
  }

  getPointLeaderboard() {
    const endpoint = config.baseURL + `Point/api/v3/GetFriendLeaderboard`;
    return this.get(endpoint);
  }

  getGreenPointById(Id: number) {
    const endpoint = config.baseURL + `Point/api/v1/Point/GetGreenPointById?id=${Id}`;
    return this.get(endpoint);
  }

  getGreenPointLeaderboard() {
    const endpoint = config.baseURL + `Point/api/v3/GetFriendLeaderboardGreenPoint`;
    return this.get(endpoint);
  }

  getDataVideo(body: any) {
    const endpoint = config.baseURL + `Reel/api/v4/GetFeed`;
    return this.post(endpoint, body);
  }

  likeVideo(body:any) {
    const endpoint = config.baseURL + `Reel/api/v4/Like`;
    return this.post(endpoint, body);
  }

  getCommentVideo(Id:number, page:number, pageSize:number) {
    const endpoint = config.baseURL + `Reel/api/v4/CommentList?reelId=${Id}&page=${page}&pageSize=${pageSize}`;
    return this.get(endpoint);
  }

  likeComment(body:any) {
    const endpoint = config.baseURL + `Reel/api/v4/LikeComment`;
    return this.post(endpoint, body);
  }

  commentVideo(body:any) {
    const endpoint = config.baseURL + `Reel/api/v4/Comment`;
    return this.post(endpoint, body);
  }

  replyCommentVideo(body:any) {
    const endpoint = config.baseURL + `Reel/api/v4/Reply`;
    return this.post(endpoint, body);
  }

  getVideoById(Id:number) {
    const endpoint = config.baseURL + `Reel/api/v4/GetFeedById?reelId=${Id}`;
    return this.get(endpoint);
  }

  getVideoProfile() {
    const endpoint = config.baseURL + `Reel/api/v4/ReelProfile`;
    return this.get(endpoint);
  }

  getVideoProfileById(userId) {
    const endpoint = config.baseURL + `Reel/api/v4/ReelProfileById?id=${userId}`;
    return this.get(endpoint);
  }

  getSearchVideo(keyword: string, page: number, pagesize: number) {
    const endpoint = config.baseURL + `Reel/api/v4/SearchReel?keyword=${keyword}&page=${page}&pageSize=${pagesize}`;
    return this.get(endpoint);
  }

  postVideo(file: any, desc: string, webUrl?: string) {
    const fd = new FormData();

    if (file) {
      fd.append('file', file, file.name || 'video.mp4');
    }

    fd.append('description', desc);

    if (webUrl) {
      fd.append('webUrl', webUrl);
    }

    const endpoint = config.baseURL + 'Reel/api/v4/PostReel';

    return this.http.post(endpoint, fd, { headers: this.authorizationHeader() });
  }

  getConfigVideo() {
    const endpoint = config.baseURL + `Reel/api/v4/ReelConfig`;
    return this.get(endpoint);
  }

  postViewVideo(reelId: any) {
    let body = {}
    const endpoint = config.baseURL + `Reel/api/v4/view?reelId=${reelId}`;
    return this.post(endpoint, body);
  }


  getVisitorSummary() {
    const endpoint = config.baseURL + `ServiceConsume/api/v1/Sammary`;
    return this.get(endpoint);
  }

  searchUserProfileByID (UserId : any) {
    const body = {
      "kind": 0,
      "keyword": "",
      "pageSize": 20,
      "page": 1
    };

    const endpoint = config.baseURL + `User/api/v4/SearchUserProfileById?id=${UserId}`;
    return this.post(endpoint, body);
  }

  getMarketPlaceList(sortby: any = '', catId: any, page: any, search: any = '', pagesize: any = 12) {
    let body = {
      sortby: sortby,
      cat: catId,
      page: page,
      pagesize: pagesize,
      search: search
    };
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/marketlist`;
    return this.post(endpoint, body);
  }

  getMarketPlaceCategory(allowInactive = true) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/category?allowinactive=${allowInactive}`;
    return this.get(endpoint);
  }

  getMarketPlaceConditionTerms() {
    const endpoint = config.baseURL + `MarketPlace/api/v2/merchant/condition`;
    return this.get(endpoint);
  }

  marketPlaceRegisterStore(body: any) {
    console.log(body);
    const fd = new FormData();
    let blob: any;
    let dt;
    let merch_img;
    let firstImgName;

    for (let i = 0; i < body.imageProducts.length; i++) {
      dt = new Date;
      blob = this.dataURItoBlob(body.imageProducts[i].Url);
      let imgName = `prod_${dt.getTime()+dt.getMonth()+dt.getDate()+dt.getFullYear()}.png`;
      fd.append('images', blob, imgName);

      if(i == 0) {
        firstImgName = imgName;
      }

      if (body.hasOwnProperty('defulteImgIndex') && body.defulteImgIndex == i) {
        fd.append('prod_img_defualt', imgName);
      }
    }

    if (!body.hasOwnProperty('defulteImgIndex') || !body.defulteImgIndex) {
      fd.append('prod_img_defualt', firstImgName);
    }

    if (body.image) {
      dt = new Date;
      blob = this.dataURItoBlob(body.image);
      merch_img = `merch_${dt.getTime()+dt.getMonth()+dt.getDate()+dt.getFullYear()}-imageStore.png`;
      fd.append('images', blob, merch_img);
    }

    if (body.hasOwnProperty('merch_cat') && body.merch_cat) fd.append('merch_cat', body.merch_cat); 
    if (body.hasOwnProperty('merch_name') && body.merch_name) fd.append('merch_name', body.merch_name); 
    if (merch_img) fd.append('merch_img', merch_img);
    if (body.hasOwnProperty('phone_number') && body.phone_number) fd.append('phone_number', body.phone_number);
    if (body.hasOwnProperty('line_id') && body.line_id) fd.append('line_id', body.line_id);
    if (body.hasOwnProperty('ig') && body.ig) fd.append('ig', body.ig);
    if (body.hasOwnProperty('facebook') && body.facebook) fd.append('facebook', body.facebook);
    if (body.hasOwnProperty('prod_detail') && body.prod_detail) fd.append('prod_detail', body.prod_detail);
    if (body.hasOwnProperty('prod_cat') && body.prod_cat) fd.append('prod_cat', body.prod_cat);
    if (body.hasOwnProperty('prod_name') && body.prod_name) fd.append('prod_name', body.prod_name);
    if (body.hasOwnProperty('prod_price') && body.prod_price) fd.append('prod_price', body.prod_price);
    if (body.hasOwnProperty('description') && body.description) fd.append('description', body.description);

    const endpoint = config.baseURL + `MarketPlace/api/v2/merchant/register`;
    return this.post(endpoint, fd);
  }

  getMarketPlaceSortingList() {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/sortinglist`;
    return this.get(endpoint);
  }

  getMarketPlaceProductInfo(productId: any) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/info?product_id=${productId}`;
    return this.get(endpoint);
  }

  getMarketPlaceProductComment(productId: any, page = 1, pageSize = 10) {
    
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/CommentList?product_id=${productId}&page=${page}&pagesize=${pageSize}`;
    return this.get(endpoint);
  }

  marketPlaceProductComment(body: any) {
    const fd = new FormData();
    let blob: any;

    fd.append('prod_id', body.prod_id);
    fd.append('comment', body.comment);

    if(body.image) {
      blob = this.dataURItoBlob(body.image);
      fd.append('image', blob, 'comment-img.png');
    }

    if(body.hasOwnProperty('replt_to') && body.replt_to) fd.append('replt_to', body.replt_to);
    if(body.hasOwnProperty('replt_to_user') && body.replt_to_user) fd.append('replt_to_user', body.replt_to_user);

    const endpoint = config.baseURL + `MarketPlace/api/v2/product/comment`;
    return this.post(endpoint, fd);
  }

  marketPlaceDeleteComment(id: any) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/deletecomment?id=${id}`;
    return this.get(endpoint);
  }

  marketPlaceInterestedProduct(body: any) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/interested`;
    return this.post(endpoint, body);
  }

  marketPlaceRatingProduct(body: any) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/rating`;
    return this.post(endpoint, body);
  }

  getMarketPlaceStoreInfo(merchantId: any) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/merchant/info/${merchantId}`;
    return this.get(endpoint);
  }

  marketPlaceCrateProduct(body: any) {
    const fd = new FormData();
    let blob: any;
    let dt;
    let firstImgName, imgDefaultName;

    fd.append('cat_id', body.prod_cat);
    fd.append('price', body.prod_price);
    fd.append('name', body.prod_name);
    if(body.hasOwnProperty('prod_detail') && body.prod_detail) fd.append('detail', body.prod_detail);
    fd.append('merchant_id', body.merchant_id);

    for (let i = 0; i < body.imageProducts.length; i++) {
      dt = new Date;
      blob = this.dataURItoBlob(body.imageProducts[i].Url);
      let imgName = `prod_${dt.getTime()+dt.getMonth()+dt.getDate()+dt.getFullYear()}.png`;
      fd.append('images', blob, imgName);

      if(i == 0) {
        firstImgName = imgName;
      }

      if(body.imageProducts[i].IsDefault) {
        imgDefaultName = imgName;
      }
    }

    if (imgDefaultName) {
      fd.append('img_default', imgDefaultName);
    } else {
      fd.append('img_default', firstImgName);
    }
    
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/create`;
    return this.post(endpoint, fd);
  }

  getMarketPlaceProductByStore(merchantId: any, sortby: any = 1, catId: any = -2, page: any, search: any = '', pagesize: any = 3000) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/bymerchant?merchantid=${merchantId}&sortby=${sortby}&cat=${catId}&page=${page}&pagesize=${pagesize}&search=${search}`;
    return this.get(endpoint);
  }

  getMarketPlaceMerchantInfo(merchantId: any) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/merchant/info/${merchantId}`;
    return this.get(endpoint);
  }

  marketPlaceMerchantUpdate(body: any) {
    const fd = new FormData();
    let blob: any;
    let dt;

    if (body.imageStore) {
      dt = new Date;
      blob = this.dataURItoBlob(body.imageStore);
      let merch_img = `prod_${dt.getTime()+dt.getMonth()+dt.getDate()+dt.getFullYear()}-imageStore.png`;
      fd.append('images', blob, merch_img);
    }

    fd.append('merchant_id', body.merchant_id);
    fd.append('merch_name', body.merch_name);
    fd.append('merch_cat', body.merch_cat);
    if (body.hasOwnProperty('phone_number') && body.phone_number) fd.append('phone_number', body.phone_number);
    if (body.hasOwnProperty('line_id') && body.line_id) fd.append('line_id', body.line_id);
    if (body.hasOwnProperty('ig') && body.ig) fd.append('ig', body.ig);
    if (body.hasOwnProperty('facebook') && body.facebook) fd.append('facebook', body.facebook);
    if (body.hasOwnProperty('description') && body.description) fd.append('description', body.description);

    const endpoint = config.baseURL + `MarketPlace/api/v2/merchant/update`;
    return this.post(endpoint, fd);
  }

  getMarketPlaceInterestedInfo(productId: any) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/interestedinfo/${productId}`;
    return this.get(endpoint);
  }

  getMarketPlaceInterested(merchantId: any, page: any, pageSize: any = 12) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/interested/${merchantId}?page=${page}&pagesize=${pageSize}`;
    return this.get(endpoint);
  }

  getMarketPlaceCustomerInterested(page: any, pageSize: any = 12) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/interestedcustomer?page=${page}&pagesize=${pageSize}`;
    return this.get(endpoint);
  }

  getMarketPlaceCanRegister() {
    const endpoint = config.baseURL + `MarketPlace/api/v2/merchant/canregister`;
    return this.get(endpoint);
  }

  marketPlaceProductUpdate(body: any) {
    const fd = new FormData();
    let blob: any;
    let dt, imgDefaultName, firstImgName;

    for (let i = 0; i < body.imageProducts.length; i++) {
      let imgName = '';
      if (!body.imageProducts[i].hasOwnProperty('Id')) {
        dt = new Date;
        blob = this.dataURItoBlob(body.imageProducts[i].Url);
        if(body.imageProducts[i].IsDefault) {
          imgName = body.imageProducts[i].Name ? body.imageProducts[i].Name : `prod_${dt.getTime()+dt.getMonth()+dt.getDate()+dt.getFullYear()}.png`;
        } else {
          imgName = `prod_${dt.getTime()+dt.getMonth()+dt.getDate()+dt.getFullYear()}.png`;
        }
        
        firstImgName = imgName;
        fd.append('images', blob, imgName);
      }

      if(i == 0) {firstImgName = firstImgName? firstImgName : body.imageProducts[i].Name;}

      if(body.imageProducts[i].IsDefault && body.imageProducts[i].hasOwnProperty('Id')) {
        imgDefaultName = body.imageProducts[i].Name;
      }
    }

    if (body.hasOwnProperty('imageProductDelete') && body.imageProductDelete.length > 0) {
      fd.append('img_delete', body.imageProductDelete.join());
    }

    if(imgDefaultName) {
      fd.append('img_default', imgDefaultName);
    } else {
      fd.append('img_default', firstImgName);
    }

    fd.append('merchant_id', body.merchant_id);
    fd.append('is_onshelf', body.is_onshelf);
    fd.append('product_id', body.product_id);
    fd.append('name', body.prod_name);
    if(body.hasOwnProperty('prod_detail') && body.prod_detail)fd.append('detail', body.prod_detail);
    fd.append('price', body.prod_price);
    fd.append('cat_id', body.prod_cat);

    const endpoint = config.baseURL + `MarketPlace/api/v2/product/update`;
    return this.post(endpoint, fd);
  }

  marketPlaceProductDelete(productId: any) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/product/delete/${productId}`;
    return this.get(endpoint);
  }

  getMarketPlaceBannerDetail(bannerId: any) {
    const endpoint = config.baseURL + `MarketPlace/api/v2/banner/info?id=${bannerId}`;
    return this.get(endpoint);
  }

  serviceSearch(keyword: any, page = 1, pageSize = 5) {
    const endpoint = config.baseURL + `Search/api/v2/Search/Service`;
    let body = {
      keyword: keyword,
      page: page,
      pageSize: pageSize
    };

    return this.post(endpoint, body);
  }

  contentSearch(keyword: any, page = 1, pageSize = 5) {
    const endpoint = config.baseURL + `Search/api/v2/Search/Content`;
    let body = {
      keyword: keyword,
      page: page,
      pageSize: pageSize
    };

    return this.post(endpoint, body);
  }

  serviceSearchList(keyword: any) {
    const endpoint = config.baseURL + `Search/api/v2/Search/List`;
    let body = {
      keyword: keyword,
    };
    
    return this.post(endpoint, body);
  }

  getRewardById(rewardId: any) {
    const endpoint = config.baseURL + `Reward/api/v1/Reward/RewardByID?ID=${rewardId}`;
    return this.get(endpoint);
  }

  getMyMerchant() {
    const endpoint = config.baseURL + `MarketPlace/api/v2/merchant/mymerchant`;
    return this.get(endpoint);
  }

  getAllActivity() {
    const endpoint = config.baseURL + `Profiling/api/v1/Profile/GetAllActivity`;
    return this.get(endpoint);
  }

  getNewsUpdate(page = 1, size = 3) {
    const endpoint = config.baseURL + `Profiling/api/v1/Profile/Content?page=${page}&pageSize=${size}`;
    return this.get(endpoint);
  }

  getHomeBanner() {
    const endpoint = config.baseURL + `Cover/api/v1/banner?type=web`;
    return this.get(endpoint);
  }

  getHomeBannerMobile() {
    const endpoint = config.baseURL + `Cover/api/v1/banner`;
    return this.get(endpoint);
  }

  
  requestOTP_OLD(phone: any) {
    const endpoint = config.baseURL + `otp/api/v1/RequestOTP?phone=${phone}`;
    return this.get(endpoint);
  }
  requestOTP(channel: any,user: any,phone: any,email:any) {
 
    const endpoint = config.baseURL + `otp/api/v1/RequestOTP?channel=${channel}&user=${user}&phone=${phone}&email=${email}`;
    return this.get(endpoint,false);
  }
  submitOTP(body: any) {
    const endpoint = config.baseURL + `otp/api/v1/SubmitOTP`;
    return this.post(endpoint, body);
  }

  public dataURItoBlob(dataURI: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    // const bb = new Blob([ab]);
    // return bb;
    return new Blob([ab], { type: mimeString }); // ✅ เพิ่ม type ที่นี่
  }

  getClassroom(url: string, isAuth = true): Observable<any> {
    return Observable.create((observer: any) => {
      const headersConfig: any = {
        'x-api-key': config.x_api_key
      };
      const httpGet = isAuth ? this.http.get(url, { headers: headersConfig }) : this.http.get(url);
      return httpGet.subscribe((data: any) => {
        if (data.Code === 403) {
          window.localStorage.removeItem(config.classRoom + '/token');
          this.router.navigate(['/signin']);
        }
        observer.next(data);
        observer.complete();
      }, (error) => {
        observer.error(error);
      });
    });
  }

  postClassroom(url: string, body: any): Observable<any> {
    return Observable.create((observer: any) => {
      const headersConfig: any = {
        'x-api-key': config.x_api_key
      };
      return this.http.post(url, body, { headers: headersConfig }).subscribe((data: any) => {
        if (data.Code === 403) {
          window.localStorage.removeItem(config.classRoom + '/token');
          this.router.navigate(['/signin']);
        }
        observer.next(data);
        observer.complete();
      }, (error) => {
        observer.error(error);
      });
    });

  }

  get(url: string, isAuth = true, suppressRedirect = false): Observable<any> {
    if (isAuth) {
      const token = window.localStorage.getItem(config.baseURL + '/token');
      if (!token) {
        return Observable.create((observer: any) => {
           observer.error({ Code: 401, Message: 'No Token' });
           observer.complete();
        });
      }
    }
    return Observable.create((observer: any) => {
      const httpGet = isAuth ? this.http.get(url, { headers: this.authorizationHeader() }) : this.http.get(url);
      return httpGet.subscribe((data: any) => {
        if (data.Code === 403 && !suppressRedirect) {
          window.localStorage.removeItem(config.baseURL + '/token');
          this.router.navigate(['/signin']);
        }
        observer.next(data);
        observer.complete();
      }, (error) => {
        observer.error(error);
      });
    });
  }

  post(url: string, body: any): Observable<any> {
    return Observable.create((observer: any) => {
      return this.http.post(url, body, { headers: this.authorizationHeader() }).subscribe((data: any) => {
        if (data.Code === 403) {
          window.localStorage.removeItem(config.baseURL + '/token');
          this.router.navigate(['/signin']);
        }
        observer.next(data);
        observer.complete();
      }, (error) => {
        observer.error(error);
      });
    });

  }

  //ton add
  getFavorite(type = 'all',page = 1, size = 10) {
    const endpoint = config.baseURL + `favorite/api/v3/FavoriteList?type=${type}&page=${page}&pageSize=${size}`;
    return this.get(endpoint);
  }

  crateFavorite(body: any) {
    const fd = new FormData();

    fd.append('contentId', body.contentId);
    fd.append('contentType', body.contentType);

    const endpoint = config.baseURL + `favorite/api/v3/create`;
    return this.post(endpoint, fd);
  }

  deleteFavorite(body: any) {
    const fd = new FormData();
    fd.append('contentId', body.contentId);
    fd.append('contentType', body.contentType);
    const endpoint = config.baseURL + `favorite/api/v3/delete`;
    return this.post(endpoint, fd);
  }

  getCommentAll(type: any,id: any, page = 1, pageSize = 10) {
    const endpoint = config.baseURL +  `content/api/v3/GetCommentByContent?contentType=${type}&contentid=${id}&page=${page}&pageSize=${pageSize}`;
    return this.get(endpoint);
  }

  getCommentList(type: any,id: any, page = 1, pageSize = 10) {
    const endpoint = config.baseURL +  `content/api/v3/GetCommentList?contentType=${type}&contentid=${id}&page=${page}&pageSize=${pageSize}`;
    return this.get(endpoint);
  }

  LikeContent(body: any) {
    console.log(body);
    const endpoint = config.baseURL + `content/api/v3/like`;
    return this.post(endpoint, body);
  }

  // Mention
  expGetUserMention(req: any) {
    const endpoint = config.baseURL +  `content/api/v3/GetMentionList?page=1&pageSize=5&contnetType=${req.type}&contnetId=${req.Id}&mention=${req.mention}&search=${req.search}`;
    return this.get(endpoint).toPromise();
  }

  comment(body: any) {
    const endpoint = config.baseURL + `content/api/v3/Comment`;
    return this.post(endpoint, body);
  }
  deleteCommentContent(id: any) {
    const fd = new FormData();
     
    const endpoint = config.baseURL +  `content/api/v3/DeleteComment?id=${id}`;
    return this.post(endpoint,fd);
  }
  editCommentContent(body: any) {

    const endpoint = config.baseURL  + `content/api/v3/EditComment`;
    return this.post(endpoint, body);
  }
   
  ContentComment(body: any) {
    const fd = new FormData();
    let blob: any;

    fd.append('content_type', body.content_type);
    fd.append('content_id', body.content_id);
    fd.append('comment', body.comment);

    if(body.image) {
      blob = this.dataURItoBlob(body.image);
      fd.append('image', blob, 'comment-img.png');
    }

    if(body.hasOwnProperty('replt_to') && body.replt_to) fd.append('replt_to', body.replt_to);
    if(body.hasOwnProperty('replt_to_user') && body.replt_to_user) fd.append('replt_to_user', body.replt_to_user);
     
    const endpoint = config.baseURL + `content/api/v3/commentcontent`;
    return this.post(endpoint, fd);
  }
  getMyPoint(){
    const endpoint = config.baseURL  + `Point/api/v3/getMyPoint`;
    return this.get(endpoint);
  }

  getSearchUserProfile(page: number = 0, pageSize: number = 20, keyword: string, kind:number =0, column: string = "FullName", ordering: string = "asc") {
    const body = {
      Page: page,
      PageSize: pageSize,
      Keyword: keyword,
      Column: column,
      Ordering: ordering,
      Kind : kind
    };
    const endpoint = config.baseURL + 'User/api/v3/searchuserprofile';
    return this.post(endpoint, body);

  }
  crateFavoriteFriend(body: any) {
    const fd = new FormData();

    fd.append('friendId', body.friendId);
    const endpoint = config.baseURL + `favoritefriend/api/v3/create`;
    return this.post(endpoint, fd);
  }

  getPointTermsTransfery( ) {
    const endpoint = config.baseURL + `pointtermstransfer/api/v3/list`;
    return this.get(endpoint);

  }

  TransferPoint(body: any) {
    const endpoint = config.baseURL + `Point/api/v3/tranferspoint`;
    return this.post(endpoint, body);
  }

  rewardRedeem(body: any) {
    const endpoint = config.baseURL + `redemption/api/v3/Redeem`;
    return this.post(endpoint,body);
  }

  getRedeemAddress( ) {
    const endpoint = config.baseURL + `redemption/api/v3/getredeemaddress`;
    return this.get(endpoint);

  }

  getBanner( ) {
    const endpoint = config.baseURL + `template/api/v3/banner?type=web`;
    return this.get(endpoint);

  }

  getAllOperationUnit( ) {
    const endpoint = config.baseURL + `operationUnit/api/v3/getAllOperationUnit`;
    return this.get(endpoint);

  }

  getLinkBanner() {
    const endpoint = config.baseURL + `Cover/api/v1/BannerLink?type=web`;
    return this.get(endpoint);
  }

  getLinkBannerMobile() {
    const endpoint = config.baseURL + `Cover/api/v1/BannerLink?type=mobile`;
    return this.get(endpoint);
  }
  // end ton add
  
  getSurveyCategoryList( page: number = 1, pageSize: number = 5, keyword: string = '') {
    const endpoint = config.baseURL + `serveycategory/api/v3/GetList?page=${page}&pageSize=${pageSize}&keyword=${keyword}`;
    return this.get(endpoint);

  }

  getSurveyTopicListByCategory(categoryId: number, page: number = 1, pageSize: number = 5, keyword: string = '') {
    const endpoint = config.baseURL + `serveytopic/api/v3/GetListByCategory?categoryId=${categoryId}&page=${page}&pageSize=${pageSize}&keyword=${keyword}`;
    return this.get(endpoint);
  }

  getSurveyQuestion(topicId: number, page: number = 1, pageSize: number = 20, keyword: string ) {
    const endpoint = config.baseURL + `serveyquestion/api/v3/GetListByTopic?topicId=${topicId}`;
    return this.get(endpoint);
  }

  getPrivacyPolicy() {
    const endpoint = config.baseURL + `privacypolicy/api/v3/get`;
    return this.get(endpoint, true, true);
  }
  agreePrivacyPolicy(body: any) {
    const endpoint = config.baseURL + `privacypolicy/api/v3/accept`;
    return this.post(endpoint, body);
  }
  sureyAnswerCrate(body: any) {
    const fd = new FormData();
    console.log(body);
    fd.append('datalist', JSON.stringify(body));
    
    const endpoint = config.baseURL + `serveyquestion/api/v3/CreateAnswer`;
    return this.post(endpoint, fd);

  }
  sureyAnswer(body: any) {
    const endpoint = config.baseURL + `serveyquestion/api/v3/AnswerSurvey`;
    return this.post(endpoint, body);

  }
  bypassAuth(body: any) {
    console.log(body);
    const endpoint = config.baseURL + 'Auth/api/v3/bypassAuth' ;
    return this.post(endpoint, body);
  }

  getSurveyHistory(categoryId: number, page: number = 1, pageSize: number = 5, keyword: string = '') {
    const endpoint = config.baseURL + `serveytopic/api/v3/GetHistoryList?categoryId=${categoryId}&page=${page}&pageSize=${pageSize}&keyword=${keyword}`;
    console.log(endpoint);
    return this.get(endpoint);
  }
  getSurveyCategoryHistoryList( page: number = 1, pageSize: number = 5, keyword: string = '') {
    const endpoint = config.baseURL + `serveycategory/api/v3/GetHistoryList?page=${page}&pageSize=${pageSize}&keyword=${keyword}`;
    return this.get(endpoint);
  }
}
